import type { AuthFor } from '#@/types';

export const authFor: AuthFor = (subject) => ({
  canI: (action) => ({
    any: () => ({ [subject]: { action, any: true } }),
    where: (where) => ({ [subject]: { action, where } }),
  }),
});
